import { useEffect, useMemo, useState } from "react";

import AppBar from "components/AppBar";
import PageLayout from "components/PageLayout";
import PageLoader from "components/PageLoader";
import useNotifier from "hooks/useNotifier";
import useBoundStore from "store";
import RoomManagerApi, { RoomManagerData, EMPTY_ROOM_MANAGER_DATA } from "api/room-manager";
import { VoteType } from "api/vote";
import Rooms from "./Rooms";

export interface TimelineRoomManagerProps {
  onBack?: () => void;
}

export default function TimelineRoomManager(props: TimelineRoomManagerProps) {
  const { onBack } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [roomManagerData, setRoomManagerData] = useState<RoomManagerData | null>(null);

  const selected = useBoundStore((state) => state.selected);
  const { timelineEvent } = selected;
  const { showNotification } = useNotifier();
  const roomManagerApi = useMemo(() => new RoomManagerApi(showNotification), [showNotification]);

  const participantIds = (timelineEvent?.votes ?? [])
    .filter((v) => v.type === VoteType.PARTICIPATING)
    .map((v) => v.uid);
  const participants = (timelineEvent?.users ?? []).filter((u) => participantIds.includes(u.uid));

  useEffect(() => {
    (async () => {
      if (timelineEvent?.event && selected.groupId) {
        const { data } = await roomManagerApi.getRoomManagerData(timelineEvent.event.id, selected.groupId);
        setRoomManagerData(data?.data ?? EMPTY_ROOM_MANAGER_DATA);
      }
      setIsLoading(false);
    })();
  }, [timelineEvent?.event?.id, selected.groupId]);

  if (isLoading) {
    return (
      <PageLayout appBar={<AppBar noRadius title='Room Manager' onBack={onBack} />}>
        <PageLoader />
      </PageLayout>
    );
  }

  return (
    <PageLayout appBar={<AppBar noRadius title='Room Manager' onBack={onBack} />} paddingBottom={false}>
      <Rooms
        data={roomManagerData ?? EMPTY_ROOM_MANAGER_DATA}
        isAdmin={false}
        participants={participants}
        viewMode
        onSave={() => {}}
      />
    </PageLayout>
  );
}
